import { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import '../Styles/WelcomeView.css';
import { useAuth } from '../contexts/AuthContext';
import { useWindow } from '../contexts/WindowContext';
import { useToast } from '../contexts/ToastContext';

export const WelcomeView = () => {
    const [isOpen, setIsOpen] = useState(false);
    const { user, updateUser } = useAuth();
    const { logoImage } = useWindow();
    const navigate = useNavigate();
    const [name, setName] = useState('');
    const toast = useToast();
    const [isLoading, setIsLoading] = useState(false);
    const nameInputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (user) {
            setName(user.name || '');
        }
    }, [user]);

    useEffect(() => {
        if (isOpen && nameInputRef.current) {
            nameInputRef.current.focus();
        }
    }, [isOpen]);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        
        if (!name.trim()) {
            toast('Name cannot be empty', 'error');
            return;
        }

        setIsLoading(true);
        try {
            updateUser({
                name: name,
                s_name: user?.s_name || '',
                s_level: user?.s_level || '',
            });
            toast('Name saved successfully', 'success');
            navigate('/settings/profile');
            setIsOpen(false);
        } catch (error) {
            toast('Failed to save name', 'error');
        } finally {
            setIsLoading(false);
        }
    };

    if (!isOpen) {
        return null;
    }

    return (
        <div className="welcome-view-modal-overlay">
            <div 
                className="welcome-view-modal"
                role="dialog" 
                aria-modal="true" 
                aria-labelledby="welcome-modal-title"
            >
                <div className="welcome-view-modal-header">
                    <img src={logoImage} alt="StudyBuddy Logo" />
                    <h1 id="welcome-modal-title">Welcome to StudyBuddy</h1>
                </div>
                
                <div className="welcome-view-modal-body">
                    <form onSubmit={handleSubmit}>
                        <label htmlFor="nameInput">What should I call you?</label>
                        <input 
                            type="text"
                            id="nameInput" 
                            placeholder="Name" 
                            value={name} 
                            onChange={(e) => setName(e.target.value)} 
                            ref={nameInputRef}
                        />
                        <button type="submit" disabled={isLoading}>
                            {isLoading ? 'Saving...' : 'Save'}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};